var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isImmowelt)?_c('div',{staticClass:"mt-200"},[_c('feedback-webcomponent',{attrs:{"product":"Anbieterprofil"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }